import { gql } from "@apollo/client";

export const UPDATE_MANUAL_RULE = gql`
  mutation updateAmlManualRule($input: UpdateAmlManualRuleInput!) {
    aml {
      updateAmlManualRule(input: $input) {
        success
      }
    }
  }
`;
